export default {
  waitlistId: (state) => state.waitlist.id,
  waitlistSettingsKey: (state) => state.waitlist.settingsKey,
  detailViewLoader: (state) => state.detailView.loading,
  waitlistProgressState: (state) => state.waitlist.progress_state,
};
